import { Competition } from './Competition'
import { Product } from './Product'
import { Image } from './Image'
import { Team } from './Team'
import { MediaAsset } from './MediaAsset'
import { Sport } from 'modules/sport/types'
import { EventScore } from './EventScore'

type JSONValue = string | { [x: string]: JSONValue } | Array<JSONValue>

export interface EventTeam extends Team {
  homeTeam: boolean
  theme?: { [key: string]: JSONValue }
}

export enum EventStatus {
  LIVE = 200,
  VOD = 600,
  UPCOMING = 300,
  TECHNICAL_ISSUE = 500
}

export interface Event {
  name: string
  description: string
  startTime: string
  endTime: string
  free: boolean
  locked: boolean
  competition: Competition
  teams: EventTeam[]
  images: Image[]
  products: Product[]
  status: EventStatus
  uuid: string
  originalRef?: string
  systemRef?: string
  createdAt: string
  updatedAt: string
  userLikes: number
  pageviews: number
  mediaAssets?: MediaAsset[]
  sport: Sport
  eventScores: EventScore[]
  product?: Product

  // Misc
  highlightGridTop?: boolean
  highlightGridBottom?: boolean
  userFollowsEvent?: boolean
}

export type ImageTypes = 'thumb' | 'cover' | 'logo'

export type ImageT = {
  imageType: ImageTypes
  url: string
}

export type VideoT = {
  id: number
  startTime: string
  endTime: string
  rating: number
  highlights: string
  videoAssets: { url: string; assetType: string }[]
}

export type EventI = {
  id: number
  name: string
  description: string
  uuid: string
  imageUrl: string
  images: ImageT[]
  competition: Competition
  createdAt: string
  updatedAt: string
  published: boolean
  startTime: string
  endTime: string
  products?: Product[]
  paid?: boolean
  product?: Product
  video?: VideoT
  status?: EventStatus
  systemRef: string
  locked: boolean
  highlightGridTop: boolean
  highlightGridBottom: boolean
  free: boolean
  teams: Team[]
  homeTeam?: boolean
  mediaAssets?: MediaAsset[]
}
